import { render, staticRenderFns } from "./OrdOutputProductNew.vue?vue&type=template&id=0e676847&"
import script from "./OrdOutputProductNew.vue?vue&type=script&lang=js&"
export * from "./OrdOutputProductNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports